import React, {FC, useEffect,useMemo, useRef, useState} from "react";
import classes from "./diamondFilterContent.module.css";
import Label from "../Label/Label";
import Button from "../Button";
import SlickSlider from "../Slider";
import InputRangeSlider from "../InputSlider";
import LabelRangeSlider from "../LabelRangeSlider";
import useDiamondFilterContent from "./useDiamondFilterConent";
import {FilterContentType} from "../../types";
import {RootState} from "../../reducers/RootReducer";
import {removeFilterKey, setFilter, setChangeMinMaxValue,setRemovedMinMaxOptions,resetRemovedMinMax} from "../../action/FilterAction";
import {setPriceLoading, setRingPrice, setRingPriceError,setRingOptions} from "../../action/RingAction";
import {setBackToSelectDiamondPage} from "../../action/DiamondAction";
import {connect, ConnectedProps} from "react-redux";
import {DiamondShapeContent} from "../../Utils/commonData";
import {useMediaQuery} from "react-responsive";

const mapStateToProps = (state: RootState) => ({
    filter: state.filter,
    ring: state.ring,
    footer: state.footer
});

const mapDispatchToProps = {
    setFilter,
    removeFilterKey,
    setChangeMinMaxValue,
    setPriceLoading,
    setRingPrice,
    setRingPriceError,
    setRingOptions,
    setBackToSelectDiamondPage,
    setRemovedMinMaxOptions,
    resetRemovedMinMax
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromDiamondFilterContentRedux = ConnectedProps<typeof connector>;

const DiamondFilterContent: FC<FilterContentType> = (props) => {
    const {
      ring,
      setChangeMinMaxValue,
      source,
      removeFilterKey,
      filter,
      color,
      clarity,
      cut,
      fluorecence,
      polish,
      symmetry,
      setBackToSelectDiamondPage,
      setRemovedMinMaxOptions,
      resetRemovedMinMax
    } = props;

    const {
      handleFilterType,
      SCS,
      setSCS,
      tooltipPadding
    } = useDiamondFilterContent(props);

    const rpid = JSON.parse(localStorage.getItem('rpid') as string);
    const builder_mode = JSON.parse(localStorage.getItem('builder_mode') as string);
    const uuid = JSON.parse(localStorage.getItem('design_uuid') as string);
    const isEditBuilder = rpid  && uuid && builder_mode === "edit" ;
    const contents = useMemo(()=>{
      return DiamondShapeContent.filter(item => !ring.exclusionOption.includes(item.code));
    },[DiamondShapeContent,ring.exclusionOption])

    const isLargeScreen = useMediaQuery({query: "(max-width: 1575px)"});
    const isTablet = useMediaQuery({query: "(max-width: 991px)"});
    const lastTabbableElementRef = useRef<HTMLInputElement>(null);
    const [number,setNumber] = useState(1);

    useEffect(()=>{
        // classes.items
        const handleTabPress = (event: KeyboardEvent) => {

                const section8Parent = document.querySelector(`.${classes.items}`)?.parentNode;
                const getFilterButton = window.document.querySelector('[name="filterButton"]') as HTMLButtonElement;
                const checkItemScreenBased = isTablet ? 5 : isLargeScreen ? 3 : 7;
                const section8 = section8Parent && section8Parent.children[checkItemScreenBased];
                if(section8){
                    const tabbableElements = Array.from(section8.querySelectorAll('input, button, textarea, select, a[href], [tabindex]:not([tabindex="-1"])'));
                    const lastTabbableElement = tabbableElements[tabbableElements.length - 1] as HTMLElement;
                    if ((!event.shiftKey && event.key === 'Tab') && document.activeElement === lastTabbableElement && getFilterButton.className.match(/\bmore_filter\b/)) {
                        event.preventDefault();
                        getFilterButton.focus();
                    } else if((event.shiftKey && event.key === 'Tab') && document.activeElement === getFilterButton){
                        if(getFilterButton.className.match(/\bmore_filter\b/)){
                            event.preventDefault();
                            lastTabbableElement.focus();
                        }
                    }
                }
            }

        document.addEventListener('keydown', handleTabPress);

        return () => {
            document.removeEventListener('keydown', handleTabPress);
        };
    })

    return (
        <>{filter.minMaxValue && Object.keys(filter.minMaxValue).length > 0 ? <>
            {/*{!filter.afterRingSelectedOptions.source && */}<div className={classes.items}>
                <Label text={"Center Diamond Type"}>
                    {source.map((name) => {
                        return (
                            <Button
                                key={name}
                                type="button"
                                className={classes.button}
                                buttonType={
                                    filter.options?.source && (name === 'Natural' ? 'GNU' : 'LGN') === filter.options.source
                                        ? "active"
                                        : undefined
                                }
                                isDisabled={!!ring.extraData.Label && !["Generic"].includes(ring.extraData.Label)}
                                onClick={() => {
                                    // setChangeMinMaxValue(true);
                                    setBackToSelectDiamondPage(false);
                                    if(name === 'Natural'){
                                        removeFilterKey("scs");
                                    }else {
                                        handleFilterType(false,"scs");
                                        setSCS(false);
                                    }
                                    if (Object.keys(ring.options).length < 1 && filter.options.source === (name === 'Natural' ? 'GNU' : 'LGN')) {
                                        resetRemovedMinMax();
                                        return removeFilterKey("source");
                                    }
                                    handleFilterType((name === 'Natural' ? 'GNU' : 'LGN'), "source")
                                    resetRemovedMinMax();
                                    // removeFilterKey("lab");
                                }
                                }
                            >
                                <span className="text-padding-top-7">{name}</span>
                            </Button>
                        );
                    })}
                </Label>
            </div>
          {/*}*/}
            {/*{!filter.afterRingSelectedOptions.shape && */}
              <div className={classes.items}>
                  <Label text={"Center Diamond Shape"}>
                      <SlickSlider
                          contents={contents}
                          removeFilterKey={removeFilterKey}
                          handleFilterType={handleFilterType}
                          filter={filter.options}
                          labelKey={"shape"}
                          setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                          setChangeMinMaxValue={setChangeMinMaxValue}
                          isMultiSelect={false}
                          isSingleEnable={false}
                          resetRemovedMinMax={resetRemovedMinMax}
                      />
                  </Label>
              </div>
          {/*}*/}
            {/*{!filter.afterRingSelectedOptions.carat &&*/} <div className={classes.items}>
                <Label text={"Carat"} tooltipPadding={tooltipPadding["carat"]}>
                    <InputRangeSlider
                        min={+filter.minMaxValue.carat.total_min_value as number}
                        max={+filter.minMaxValue.carat.total_max_value as number}
                        selectedValue={!filter.removedMinMax['carat'] ? [+filter.minMaxValue.carat.min_value as number,+filter.minMaxValue.carat.max_value as number]:undefined}
                        rangeValue={isEditBuilder ? (filter.options.carat as string)?.split('-') : ((filter.afterRingSelectedOptions.carat as string)?.split('-') || (filter.options.carat as string)?.split('-'))}
                        step={0.01}
                        isShowDollar={false}
                        keyName={"carat"}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        options={filter.options}
                        isReset={filter.isReset}
                        setRemovedMinMaxOptions={setRemovedMinMaxOptions}
                    />
                </Label>
            </div>{/*}*/}
            <div className={classes.items}>
                <Label text={"Diamond Price"}>
                    <InputRangeSlider
                        min={+filter.minMaxValue.b2c_price.total_min_value as number}
                        max={+filter.minMaxValue.b2c_price.total_max_value as number}
                        selectedValue={!filter.removedMinMax['diamond_price'] ? [+filter.minMaxValue.b2c_price.min_value as number,+filter.minMaxValue.b2c_price.max_value as number]:undefined}
                        rangeValue={(filter.options.diamond_price as string)?.split('-')}
                        step={1}
                        isShowDollar={true}
                        keyName={"diamond_price"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        options={filter.options}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        isReset={filter.isReset}
                        setRemovedMinMaxOptions={setRemovedMinMaxOptions}
                    />
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"Color"} tooltipPadding={tooltipPadding["color"]}>
                    <LabelRangeSlider
                        mark={color}
                        keyName={"color"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        filter={filter}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        rangeValue={(filter.options.color as string)?.split('-')}
                    />
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"Cut"}>
                    <LabelRangeSlider
                        mark={cut}
                        keyName={"cut"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        filter={filter}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        rangeValue={(filter.options.cut as string)?.split('-')}
                    />
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"Clarity"} tooltipPadding={tooltipPadding["clarity"]}>
                    <LabelRangeSlider
                        mark={clarity}
                        keyName={"clarity"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        filter={filter}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        rangeValue={(filter.options.clarity as string)?.split('-')}

                    />
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"Certification"}
                       endSideContent={
                           filter.options?.source !== "GNU" ? <div className={`${classes.checkmark} cursor-pointer`} onClick={()=>{
                               setSCS(scs => !scs);
                               handleFilterType(!SCS,'scs' )}}>
                               <input type={"checkbox"}
                                      id={'scs-007'}
                                      checked={SCS}
                                      readOnly={true}
                               />
                               <Label text={"SCS-007"}>
                                    <label htmlFor={'scs-007'} className={'cursor-pointer'}/>
                               </Label>
                           </div> : null
                       }
                >
                    {["GIA","IGI", "GCAL"].map((name) => {
                        const findLab = Array.isArray(filter.options?.lab) && filter.options?.lab.find(f => f === name.toUpperCase());
                        return (
                            <Button
                                key={name}
                                type="button"
                                className={`${classes.button} ${name === "GCAL" ? "gcal_button": ''}`}
                                buttonType={
                                    name === findLab
                                        ? "active"
                                        : undefined
                                }
                                // isDisabled={filter.options.source === 'GNU' ? name === "GIA"  : filter.options.source === "LGN" ?  ["IGI", "GCAL"].includes(name) : undefined}
                                onClick={() => {
                                    setBackToSelectDiamondPage(false);
                                    setChangeMinMaxValue(false);
                                    if (Array.isArray(filter.options?.lab) && findLab) {
                                        const filterLab = filter.options?.lab.filter(f => f !== name.toUpperCase());
                                        if (filterLab.length === 0) {
                                            return removeFilterKey("lab")
                                        }
                                        return handleFilterType(filterLab, "lab")
                                    }
                                    if (filter.options?.lab) {
                                        handleFilterType([...filter.options?.lab as string | string[], name.toUpperCase()], "lab")
                                    } else {
                                        handleFilterType([name.toUpperCase()], "lab")
                                    }
                                }}
                            >
                                <span className="text-padding-top-7">{name}</span>
                            </Button>
                        );
                    })}
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"L:W Ratio"}>
                    <InputRangeSlider
                        min={+filter.minMaxValue.ratio.total_min_value as number}
                        max={+filter.minMaxValue.ratio.total_max_value as number}
                        selectedValue={!filter.removedMinMax['ratio'] ? [+filter.minMaxValue.ratio.min_value as number,+filter.minMaxValue.ratio.max_value as number]:undefined}
                        step={0.01}
                        isShowDollar={false}
                        keyName={"ratio"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        options={filter.options}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        isReset={filter.isReset}
                        rangeValue={(filter.options.ratio as string)?.split('-')}
                        setRemovedMinMaxOptions={setRemovedMinMaxOptions}
                    />
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"Fluorescence"}>
                    <LabelRangeSlider
                        mark={fluorecence}
                        keyName={"fluorecence"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        filter={filter}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        rangeValue={(filter.options.fluorecence as string)?.split('-')}
                    />
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"Polish"}>
                    <LabelRangeSlider
                        mark={polish}
                        keyName={"polish"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        filter={filter}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        rangeValue={(filter.options.polish as string)?.split('-')}
                    />
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"Symmetry"}>
                    <LabelRangeSlider
                        mark={symmetry}
                        keyName={"symmetry"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        filter={filter}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        rangeValue={(filter.options.symmetry as string)?.split('-')}
                    />
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"Table (%)"}>
                    <InputRangeSlider
                        min={+filter.minMaxValue.tbl.total_min_value as number}
                        max={+filter.minMaxValue.tbl.total_max_value as number}
                        selectedValue={!filter.removedMinMax['table_per'] ? [+filter.minMaxValue.tbl.min_value as number,+filter.minMaxValue.tbl.max_value as number]:undefined}
                        isShowDollar={false}
                        step={0.01}
                        keyName={"table_per"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        options={filter.options}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        isReset={filter.isReset}
                        rangeValue={(filter.options.table_per as string)?.split('-')}
                        setRemovedMinMaxOptions={setRemovedMinMaxOptions}
                    />
                </Label>
            </div>
            <div className={classes.items}>
                <Label text={"Depth (%)"}>
                    <InputRangeSlider
                        min={+filter.minMaxValue.depth.total_min_value as number}
                        max={+filter.minMaxValue.depth.total_max_value as number}
                        selectedValue={!filter.removedMinMax['depth'] ? [+filter.minMaxValue.depth.min_value as number,+filter.minMaxValue.depth.max_value as number]:undefined}
                        isShowDollar={false}
                        step={0.01}
                        keyName={"depth"}
                        handleFilterType={handleFilterType}
                        removeFilterKey={removeFilterKey}
                        options={filter.options}
                        setBackToSelectDiamondPage={setBackToSelectDiamondPage}
                        setChangeMinMaxValue={setChangeMinMaxValue}
                        isReset={filter.isReset}
                        rangeValue={(filter.options.depth as string)?.split('-')}
                        setRemovedMinMaxOptions={setRemovedMinMaxOptions}
                    />
                </Label>
            </div>
        </> : null}
        </>
    )
}
export default connector(DiamondFilterContent);
